require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-rob-merrill.json") })
        }
      }, "path---blog-author-rob-merrill");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-rob-merrill!./.cache/json/blog-author-rob-merrill.json
// module id = 700
// module chunks = 231608221292675